const es = {

    title: {
        content : "Senior Fullstack Developer"
    },
    bio : {
        content_1: "Hola, soy Diego. Me dedico al desarrollo de software.",
        content_2: "Hace más de 10 años que creo aplicaciones web para empresas que necesitan herramientas más rápidas y claras para su día a día.",
        content_3: "Me gusta trabajar en productos que se usan de verdad.",
        content_4: "De esos que le ahorran trabajo al equipo y que el usuario entiende sin manual.",
        content_5: "Trabajé en empresas de distintos tamaños, en salud, educación, turismo y HRTech, y aprendí un montón de los equipos que me crucé en el camino.",
        content_6: "Hoy trabajo con desarrollo asistido por IA y Spec-Driven Development: primero dejo claro qué hay que construir, y después uso Claude Code y Cursor para entregarlo más rápido y con menos errores.",
        content_7: "Intento que la tecnología haga una cosa: resolver el problema sin crear uno nuevo.",
        content_8: "Una buena aplicación funciona como debe, todos los días. (Con eso ya estoy contento.)",
        content_9: "Acá podés ver algunos de los proyectos y experiencias que me trajeron hasta acá."
    },
    descriptionHyperlinks:{
        content_1 :''
    },
    hyperlinks : {
        content_0: "Descarga gratis la guía [DEV 101] \n Tips invaluables para potenciar tu carrera dev",
        content_1: "Trayectoria",
        content_2: "Portofolio",
        content_3: "Sitio web",
        content_4: "X (Twitter)",
        content_5: "Contactame",
        
    }
  };

export default es;
